// highlight.ts
import type { Highlight } from '../types';
import { deserializeRange } from './textOffset';
import { noteColorForHighlight } from './noteColor';
import { isOwnHighlight } from './isOwnHighlight';

export function removeHighlights() {
    document.querySelectorAll('.text-highlight').forEach((el) => {
        el.remove();
    });
}

// Рисуем подсветку текстовой заметки как оверлей-дивы (не трогаем сам text layer).
// Позиционные заметки рисуются в React, сюда не попадают.
export function renderHighlight(
    highlight: Highlight,
    textLayer: HTMLElement,
    overlayLayer: HTMLElement,
    onHover: (h: Highlight, el: HTMLElement) => void,
    onLeave: () => void,
    onClick: (h: Highlight, el: HTMLElement) => void
) {
    if (highlight.type !== 'text') return;

    const range = deserializeRange(textLayer, highlight.startOffset, highlight.endOffset);
    if (!range) {
        console.warn('Не удалось восстановить выделение', highlight.id);
        return;
    }

    const layerRect = overlayLayer.getBoundingClientRect();
    const rects = Array.from(range.getClientRects());

    // Для каждого прямоугольника (строки) создаём div
    rects.forEach((rect) => {
        // Вырожденные боксы (переносы строк, схлопнутые границы диапазона)
        // невидимы, но ловят клики и сбивают скролл к заметке - пропускаем
        if (rect.width < 1 || rect.height < 1) return;

        const div = document.createElement('div');
        div.className = 'text-highlight';
        div.dataset.highlightId = highlight.id;
        div.style.cssText = `
      position: absolute;
      top: ${rect.top - layerRect.top}px;
      left: ${rect.left - layerRect.left}px;
      width: ${rect.width}px;
      height: ${rect.height}px;
      background: ${noteColorForHighlight(isOwnHighlight(highlight), highlight.persistStatus).fill};
      pointer-events: all;
      cursor: pointer;
      border-radius: 2px;
    `;

        div.addEventListener('mouseenter', () => onHover(highlight, div));
        div.addEventListener('mouseleave', () => onLeave());
        div.addEventListener('click', (e) => {
            e.stopPropagation();
            onClick(highlight, div);
        });

        overlayLayer.appendChild(div);
    });
}
